export default __webpack_public_path__ + "static/media/ded-tools-other.9171e4f7.svg";